<template>
  <div class="login">
    <div v-if="sendCodeLimitFlag" class="send-code-limit-text">
      发送频率超过限制
    </div>
    <div v-if="neverRegisterFlag" class="send-code-limit-text">
      手机号未注册，请使用微信扫码登录后注册
    </div>

    <!--   二维码登录   -->
    <template v-if="!loginBindFlag">
      <div class="right-wrap">
        <div class="close-btn" @click="onCloseClick"></div>
        <div class="login-text1">欢迎登录</div>
        <div class="login-switch" v-if="!$store.getters.isAppstoreMode">
          <div
            :class="{
              'login-switch-item': true,
              active: loginWayFlag,
            }"
            @click="switchLoginWayClick(true)"
          >
            微信登录
          </div>
          <div
            :class="{
              'login-switch-item': true,
              active: !loginWayFlag,
            }"
            @click="switchLoginWayClick(false)"
          >
            手机登录
          </div>
        </div>
        <div class="login-container" v-if="loginWayFlag">
          <div class="qrcode">
            <iframe
              :src="loginSrc"
              sandbox="allow-scripts allow-top-navigation allow-same-origin"
              v-if="isCheckedXieyi1"
              scrolling="no"
            ></iframe>
            <div v-else class="un-checked-xieyi-img"></div>
          </div>
          <div class="login-text2">使用微信扫一扫登录</div>
          <!-- <div class="login-text3">登录即注册</div> -->
          <div class="xieyi" :class="{ xieyiShake: shakeFlag1 }">
            <div
              :class="{
                'checked-xieyi': true,
                'un-checked-xieyi': !isCheckedXieyi1,
                shake: shakeFlag1,
              }"
              @click="checkClick"
            ></div>
            <div class="xieyi-text">
              我已阅读并接受<span
                @click="openUrl('https://www.ionewu.com/JdxbUProtocol.html')"
                >用户协议</span
              >和<span
                @click="
                  openUrl('https://www.ionewu.com/JdxbPrivacyProtocol.html')
                "
                >隐私政策</span
              >
            </div>
          </div>
        </div>

        <!--   手机号登录   -->
        <div class="login-container login-container-way2" v-else>
          <div
            :class="{
              'input-wrap': true,
              'phone-wrap': true,
              'input-wrap-hover': phoneActiveIcon,
            }"
          >
            <img
              src="../assets/login/account-icon.svg"
              v-if="!phoneActiveIcon"
            />
            <img src="../assets/login/account-icon.svg" v-else />
            <input
              v-model="phone"
              ref="phoneInput"
              placeholder="请输入手机号"
              class="phone"
              type="number"
              v-on:input="inputFun(1)"
              @focus="phoneInputFocus"
            />
            <div
              class="phone-error1"
              v-if="phoneErr1"
              @click="hidePhoneErr1Click"
            >
              请输入手机号
            </div>
            <div
              class="phone-error2"
              v-if="phoneErr2"
              @click="hidePhoneErr2Click"
            >
              请输入正确的手机号
            </div>
          </div>
          <div
            :class="{
              'input-wrap': true,
              'code-wrap': true,
              'input-wrap-hover': codeActiveIcon,
            }"
          >
            <img
              src="../assets/login/password-icon.svg"
              v-if="!codeActiveIcon"
            />
            <img src="../assets/login/password-icon.svg" v-else />
            <div
              :class="{
                'code-btn': true,
                countdown: countdownFlag,
              }"
              @click="sendCodeClick"
            >
              {{ codeBtnText }}
            </div>
            <input
              v-model="code"
              ref="codeInput"
              placeholder="请输入验证码"
              class="code"
              type="number"
              v-on:input="inputFun(2)"
              @focus="codeInputFocus"
            />
            <div class="code-error1" v-if="codeErr1" @click="hideCodeErr1Click">
              请输入验证码
            </div>
            <div class="code-error2" v-if="codeErr2" @click="hideCodeErr2Click">
              验证码错误
            </div>
          </div>
          <div class="login-btn" @click="loginClick">登录</div>
          <div class="xieyi" :class="{ xieyiShake: shakeFlag }">
            <div
              :class="{
                'checked-xieyi': true,
                'un-checked-xieyi': !isCheckedXieyi,
                shake: shakeFlag,
              }"
              @click="checkClick"
            ></div>
            <div class="xieyi-text">
              我已阅读并接受<span
                @click="openUrl('https://www.ionewu.com/JdxbUProtocol.html')"
                >服务协议</span
              >和<span
                @click="
                  openUrl('https://www.ionewu.com/JdxbPrivacyProtocol.html')
                "
                >隐私政策</span
              >
            </div>
          </div>
        </div>
      </div>
    </template>

    <!--   绑定手机号   -->
    <div
      class="login-container login-container-way2 login-bind-wrap"
      v-if="loginBindFlag"
    >
      <div class="login-text1">欢迎您</div>
      <img :src="loginBindAvatar" class="bind-icon" />
      <div class="bind-name">{{ loginBindName }}</div>
      <div class="bind-tip">为了您的账户安全，请绑定手机</div>
      <div class="input-wrap phone-wrap">
        <img src="../assets/login/phone.png" v-if="!phoneActiveIcon" />
        <img src="../assets/login/phone_active.png" v-else />
        <input
          v-model="phone"
          ref="phoneInput"
          placeholder="手机号"
          class="phone"
          type="number"
          v-on:input="inputFun(1)"
          @focus="phoneInputFocus"
        />
        <div class="phone-error1" v-if="phoneErr1" @click="hidePhoneErr1Click">
          请输入手机号
        </div>
        <div class="phone-error2" v-if="phoneErr2" @click="hidePhoneErr2Click">
          请输入正确的手机号
        </div>
      </div>
      <div class="input-wrap code-wrap">
        <img src="../assets/login/code.png" v-if="!codeActiveIcon" />
        <img src="../assets/login/code_active.png" v-else />
        <div
          :class="{ 'code-btn': true, countdown: countdownFlag }"
          @click="sendLoginBindCodeClick"
        >
          {{ codeBtnText }}
        </div>
        <input
          v-model="code"
          ref="codeInput"
          placeholder="验证码"
          class="code"
          type="number"
          v-on:input="inputFun(2)"
          @focus="codeInputFocus"
        />
        <div class="code-error1" v-if="codeErr1" @click="hideCodeErr1Click">
          请输入短信验证码
        </div>
        <div class="code-error2" v-if="codeErr2" @click="hideCodeErr2Click">
          验证码填写错误
        </div>
      </div>
      <div>
        <div class="bind-skip" @click="bindSkipClick">暂不绑定</div>
        <div class="login-btn" @click="loginBindClick">立即绑定</div>
      </div>
    </div>

    <!-- <div
      class="go-server-btn"
      @click="goServerPage"
      v-if="
        ($store.state.client == 'mac' || $store.state.client == 'windows') &&
        $store.state.version > '2.3.2' &&
        !$store.getters.isAppstoreMode
      "
    >
      获取本机绑定码
    </div> -->
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { mapMutations } from "vuex";
export default {
  name: "Login",
  data: function () {
    return {
      isCheckedXieyi: true, //true勾选协议，false没有勾选协议
      isCheckedXieyi1: true, //true勾选协议，false没有勾选协议
      shakeFlag: false, //true抖动协议，false不抖动
      shakeFlag1: false, //true抖动二维码方式登录的协议，false不抖动
      loginWayFlag: true, //true二维码，false手机号
      phone: "",
      code: "",
      phoneActiveIcon: false, //true获取焦点时显示黄色图标，false显示灰色图标
      codeActiveIcon: false, //true获取焦点时显示黄色图标，false显示灰色图标
      phoneErr1: false, //手机号错误提示1
      phoneErr2: false, //手机号错误提示2
      codeErr1: false, //验证码错误提示1
      codeErr2: false, //验证码错误提示2
      codeBtnText: "获取验证码", //获取验证码文本，或者倒计时文本
      countdownFlag: false, //true启动倒计时
      loginBindFlag: false, //true打开绑定面板
      loginBindAvatar: "",
      loginBindName: "",
      sendCodeLimitFlag: false, //true显示发送频率超过限制的提示
      neverRegisterFlag: false, //true显示手机号未注册的提示
    };
  },
  components: {},
  computed: {
    loginSrc: function () {
      let _that = this;
      //扫码后跳转的链接
      let r =
        window.location.protocol +
        "//" +
        window.location.host +
        _that.$router.options.base +
        "home";
      let client = "";
      if (
        _that.$route.query.client == "windows" ||
        _that.$store.state.client == "windows"
      ) {
        client = "?client=windows";
      } else if (
        _that.$route.query.client == "mac" ||
        _that.$store.state.client == "mac"
      ) {
        client = "?client=mac";
      } else {
        client = "?client=web";
      }
      if (_that.$route.query.host) {
        client += "&host=" + encodeURIComponent(_that.$route.query.host);
      }
      if (_that.$route.query.pid) {
        client += "&pid=" + encodeURIComponent(_that.$route.query.pid);
      }

      if (_that.$route.query.t) {
        client += "&t=" + encodeURIComponent(_that.$route.query.t);
      }

      if (_that.$route.query.s) {
        client += "&s=" + encodeURIComponent(_that.$route.query.s);
      }

      var src =
        process.env.NODE_ENV === "development" ? r + client : r + client;

      var redirect_uri = encodeURIComponent(
        "http://www.ionewu.com/wx_login.html?url=" + encodeURIComponent(src)
      );

      return (
        "https://open.weixin.qq.com/connect/qrconnect?appid=wxa64ad1d6cb625050&redirect_uri=" +
        redirect_uri +
        "&response_type=code&scope=snsapi_login&state=#wechat_redirect"
      );
    },
  },
  methods: {
    ...mapActions([
      "sendUserlog",
      "login",
      "sendCode",
      "phoneLogin",
      "sendLoginBindCode",
      "loginBind",
    ]),
    ...mapMutations(["setUser"]),
    onCloseClick: function () {
      this.$emit("onCloseClick");
    },
    goServerPage: function () {
      let _that = this;
      window.location.href =
        "http://yc.iepose.com/jdxb_server_pc_v4/?client=" +
        _that.$store.state.client +
        "&version=" +
        _that.$store.state.version;
    },

    openUrl: function (url) {
      let _that = this;
      _that.$common.bridge(_that.$store.state.client).openBrowser(url);
    },
    hideClientClick: function () {
      let _that = this;
      if (_that.$store.state.client == "windows") {
        window.external.miniWindow && window.external.miniWindow();
      } else if (_that.$store.state.client == "mac") {
        window.webkit.messageHandlers.miniWindow &&
          window.webkit.messageHandlers.miniWindow.postMessage({});
      }
    },
    closeClientClick: function () {
      let _that = this;
      if (_that.$store.state.client == "windows") {
        window.external.closeWindow && window.external.closeWindow();
      } else if (_that.$store.state.client == "mac") {
        window.webkit.messageHandlers.closeWindow &&
          window.webkit.messageHandlers.closeWindow.postMessage({});
      }
    },
    bindSkipClick: function () {
      let _that = this;
      //清除登录绑定缓存
      _that.$common.localStorage.removeItem("jdxb-login-bind-flag");
      //去home页

      _that.$router.push({
        path: "/",
        query: _that.$route.query,
      });
    },
    loginBindClick: function () {
      let _that = this;

      if (
        _that.phone == "" ||
        _that.phone.length != 11 ||
        _that.code == "" ||
        _that.code.length != 6
      ) {
        if (_that.phone == "") {
          _that.phoneErr1 = true;
        } else if (_that.phone.length != 11) {
          _that.phoneErr2 = true;
        }

        if (_that.code == "") {
          _that.codeErr1 = true;
        } else if (_that.code.length != 6) {
          _that.codeErr2 = true;
        }
      } else {
        let uid = localStorage.getItem("jdxb-uid");
        _that.loginBind([
          _that.phone,
          _that.code,
          uid,
          function (err, data) {
            if (data.rtn == 0) {
              //清除登录绑定缓存
              _that.$common.localStorage.removeItem("jdxb-login-bind-flag");
              _that.$common.localStorage.setItem("jdxb-phone", _that.phone);
              //去home页
              _that.$router.push({
                path: "/",
                query: _that.$route.query,
              });
            } else {
              _that.codeErr2 = true;
            }
          },
        ]);
      }
    },
    hideCodeErr2Click: function () {
      let _that = this;
      _that.codeErr2 = false;
      _that.$refs.codeInput.focus();
    },
    hideCodeErr1Click: function () {
      let _that = this;
      _that.codeErr1 = false;
      _that.$refs.codeInput.focus();
    },
    hidePhoneErr2Click: function () {
      let _that = this;
      _that.phoneErr2 = false;
      _that.$refs.phoneInput.focus();
    },
    hidePhoneErr1Click: function () {
      let _that = this;
      _that.phoneErr1 = false;
      _that.$refs.phoneInput.focus();
    },
    codeInputFocus: function () {
      let _that = this;
      //显示黄色激活图标
      _that.codeActiveIcon = true;
    },
    phoneInputFocus: function () {
      let _that = this;
      //显示黄色激活图标
      _that.phoneActiveIcon = true;
    },
    checkClick: function () {
      let _that = this;
      if (_that.loginWayFlag) {
        //选择二维码方式登录的
        _that.isCheckedXieyi1 = !_that.isCheckedXieyi1;

        if (!_that.isCheckedXieyi1) {
          setTimeout(function () {
            _that.shakeFlag1 = !_that.shakeFlag1;
          }, 1000);
        }
        if (_that.isCheckedXieyi1) {
          _that.shakeFlag1 = false;
        }
      } else {
        //选择手机号方式登录的
        _that.isCheckedXieyi = !_that.isCheckedXieyi;
        if (_that.isCheckedXieyi) {
          _that.shakeFlag = false;
        }
      }
    },
    switchLoginWayClick: function (flag) {
      let _that = this;
      _that.loginWayFlag = flag;
      if (!_that.loginWayFlag) {
        //切换为手机号登录
        _that.isCheckedXieyi = false;
        _that.shakeFlag = false;

        _that.phoneErr1 = false; //切换后重置错误提示
        _that.phoneErr2 = false;
        _that.codeErr1 = false;
        _that.codeErr2 = false;
      } else {
        //切换为二维码登录
        _that.isCheckedXieyi1 = true;
        _that.shakeFlag1 = false;
      }
    },
    inputFun: function (flag) {
      let _that = this;
      if (flag == 1) {
        if (_that.phone.length > 11) {
          _that.phone = _that.phone.slice(0, 11);
        }
      } else {
        if (_that.code.length > 6) {
          _that.code = _that.code.slice(0, 6);
        }
      }
    },
    loginClick: function () {
      let _that = this;
      if (
        _that.phone == "" ||
        _that.phone.length != 11 ||
        _that.code == "" ||
        _that.code.length != 6 ||
        !_that.isCheckedXieyi
      ) {
        if (_that.phone == "") {
          _that.phoneErr1 = true;
        } else if (_that.phone.length != 11) {
          _that.phoneErr2 = true;
        }

        if (_that.code == "") {
          _that.codeErr1 = true;
        } else if (_that.code.length != 6) {
          _that.codeErr2 = true;
        }

        //是否勾选协议
        if (!_that.isCheckedXieyi) {
          _that.shakeFlag = true;
        }
      } else {
        _that.phoneLogin([
          _that.phone,
          _that.code,
          function (err, data) {
            if (data.rtn == 0) {
              data.data.headimgurl = data.data.headimgurl
                ? data.data.headimgurl
                : "";
              data.data.nick = data.data.nick ? data.data.nick : "";

              _that.$common.localStorage.setItem("jdxb-uid", data.data.uid);
              if (data.data.openid) {
                _that.$common.localStorage.setItem(
                  "jdxb-openid",
                  data.data.openid
                );
              }
              _that.$common.localStorage.setItem("jdxb-name", data.data.nick);
              _that.$common.localStorage.setItem(
                "jdxb-avatar",
                data.data.headimgurl
              );
              _that.$common.localStorage.setItem(
                "jdxb-owcode",
                data.data.owcode
              );
              _that.$common.localStorage.setItem("jdxb-rkey", data.data.rkey);
              _that.$common.localStorage.setItem(
                "jdxb-phone",
                data.data.phone ? data.data.phone : _that.phone
              );

              _that.setUser();

              _that.sendUserlog(["login", JSON.stringify(data)]);

              _that.$store.state.isShowLogin = false;

              //   _that.$router.push({
              //     path: "/",
              //     query: _that.$route.query,
              //   });

              window.location.reload();
            } else {
              _that.codeErr2 = true;
            }
          },
        ]);
      }
    },

    sendLoginBindCodeClick: function () {
      let _that = this;

      if (_that.phone == "" || _that.phone.length != 11) {
        //发送验证码前校验手机号
        if (_that.phone == "") {
          _that.phoneErr1 = true;
        } else if (_that.phone.length != 11) {
          _that.phoneErr2 = true;
        }
      } else {
        //倒计时
        if (_that.codeBtnText.indexOf("获取验证码") != -1) {
          let endTime = localStorage.getItem("jdxb-endTime");
          let currentTime = new Date().getTime();

          if (endTime > currentTime) {
            //提示不能发送验证码（不能发送验证码，可以不影响倒计时）
            _that.sendCodeLimitFlag = true;
            setTimeout(function () {
              _that.sendCodeLimitFlag = false;
            }, 2500);
          } else {
            let uid = localStorage.getItem("jdxb-uid");
            _that.sendLoginBindCode([
              _that.phone,
              uid,
              function (err, data) {
                if (data.rtn == 0) {
                }
                _that.sendUserlog([
                  "sendLoginBindCode",
                  JSON.stringify(err) + JSON.stringify(data),
                ]);
              },
            ]);
          }

          //开始倒计时
          _that.$common.localStorage.setItem(
            "jdxb-endTime",
            new Date().getTime() + 60000
          );
          _that.countdown(60);
        }
      }
    },
    countdown: function (leftTime) {
      let _that = this;
      //倒计时
      let time = setTimeout(function () {
        if (leftTime > 1) {
          --leftTime;
          _that.countdownFlag = true;
          _that.codeBtnText = leftTime + "秒后可重发";
          _that.countdown(leftTime);
        } else {
          _that.countdownFlag = false;
          _that.codeBtnText = "获取验证码";
          _that.$common.localStorage.removeItem("jdxb-endTime");
          clearTimeout(time);
        }
      }, 1000);
    },
    sendCodeClick: function () {
      let _that = this;

      if (_that.phone == "" || _that.phone.length != 11) {
        //发送验证码前校验手机号
        if (_that.phone == "") {
          _that.phoneErr1 = true;
        } else if (_that.phone.length != 11) {
          _that.phoneErr2 = true;
        }
      } else {
        //倒计时
        if (_that.codeBtnText.indexOf("获取验证码") != -1) {
          let endTime = localStorage.getItem("jdxb-endTime");
          let currentTime = new Date().getTime();

          if (endTime > currentTime) {
            //提示不能发送验证码（不能发送验证码，可以不影响倒计时）
            _that.sendCodeLimitFlag = true;
            setTimeout(function () {
              _that.sendCodeLimitFlag = false;
            }, 2500);
          } else {
            _that.sendCode([
              _that.phone,
              function (err, data) {
                //没有用二维码登录过的用户不能使用手机号登录
                if (data.rtn == 10102) {
                  _that.neverRegisterFlag = true;
                  setTimeout(function () {
                    _that.neverRegisterFlag = false;
                  }, 2500);
                }

                // else if(data.rtn == 0){
                //     //提示已发送验证码
                // }

                _that.sendUserlog([
                  "sendCode",
                  JSON.stringify(err) + JSON.stringify(data),
                ]);
              },
            ]);
          }

          //开始倒计时
          _that.$common.localStorage.setItem(
            "jdxb-endTime",
            new Date().getTime() + 60000
          );
          _that.countdown(60);
        }
      }
    },
  },
  mounted() {
    let _that = this;
    //扫码后跳转过来
    if (_that.$store.getters.isAppstoreMode) {
      _that.switchLoginWayClick(false);
    } else {
      _that.switchLoginWayClick(true);
    }
    let code = _that.$route.query.code;
    if (code) {
      _that.login([
        code,
        function (err, data) {
          // console.log("login", data);
          if (data && data.rtn == 0) {
            data.data.headimgurl = data.data.headimgurl
              ? data.data.headimgurl
              : "";
            data.data.nick = data.data.nick ? data.data.nick : "";
            _that.$common.localStorage.setItem("jdxb-uid", data.data.uid);
            _that.$common.localStorage.setItem("jdxb-openid", data.data.openid);
            _that.$common.localStorage.setItem("jdxb-name", data.data.nick);
            _that.$common.localStorage.setItem(
              "jdxb-avatar",
              data.data.headimgurl
            );
            _that.$common.localStorage.setItem("jdxb-owcode", data.data.owcode);
            _that.$common.localStorage.setItem("jdxb-rkey", data.data.rkey);
            if (data.data.phone) {
              _that.$common.localStorage.setItem("jdxb-phone", data.data.phone);
            }

            _that.setUser();

            //没有返回手机号则需要去绑定
            // if (!data.data.phone) {
            // 	_that.loginBindAvatar = data.data.headimgurl;
            // 	_that.loginBindName = data.data.nick;
            // 	_that.loginBindFlag = true;
            // 	_that.$common.localStorage.setItem(
            // 		"jdxb-login-bind-flag",
            // 		"1"
            // 	); //1需要去绑定
            // } else {
            // 	_that.$router.push({
            // 		path: "/",
            // 		query: _that.$route.query,
            // 	});
            // }

            // 不校验绑定手机，直接跳转主页
            _that.$router.push({
              path: "/",
              query: _that.$route.query,
            });
          }
          _that.sendUserlog(["login", JSON.stringify(data)]);
        },
      ]);
    } else {
      //已登录但是没有绑定手机号的情况
      let _that = this;
      let localStorageLoginBindFlag = localStorage.getItem(
        "jdxb-login-bind-flag"
      ); //1需要去绑定
      if (localStorageLoginBindFlag == "1") {
        _that.loginBindAvatar = localStorage.getItem("jdxb-avatar");
        _that.loginBindName = localStorage.getItem("jdxb-name");
        _that.loginBindFlag = true;
      }
    }
  },
};
</script>

<style lang="less" scoped>
.go-server-btn {
  position: absolute;
  width: 314px;
  height: 48px;
  right: 110px;
  bottom: 35px;

  background: #1f5de3;
  box-shadow: 0px 6px 16px rgba(132, 132, 134, 0.12);
  border-radius: 4px;

  background-image: url(../assets/login/go-server-icon.svg);
  background-repeat: no-repeat;
  background-size: 30px 30px;
  background-position: right 15px center;

  font-weight: 600;
  font-size: 14px;
  line-height: 48px;
  color: #ffffff;
  padding-left: 15px;
  box-sizing: border-box;
}
.go-server-btn:hover {
  cursor: pointer;
  opacity: 0.9;
}

.hide-icon {
  position: absolute;
  right: 65px;
  top: 15px;
  width: 20px;
  height: 20px;
  padding: 5px;
  cursor: pointer;
}

.close-icon {
  position: absolute;
  right: 20px;
  top: 15px;
  width: 20px;
  height: 20px;
  padding: 5px;
  cursor: pointer;
  opacity: 0.9;
  z-index: 2;
}

.login {
  width: 100%;
  height: 100%;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 9;
  background-color: rgba(0, 0, 0, 0.3);

  .send-code-limit-text {
    position: absolute;
    top: 20px;
    right: 78px;
    width: 380px;
    height: 45px;
    line-height: 45px;
    text-align: center;
    background-color: #f1403b;
    border-radius: 4px;
    color: #ffffff;
  }

  .logo {
    position: absolute;
    left: 48px;
    top: 48px;
    width: 142px;
    height: 45px;
  }
  .bg {
    margin-top: 141px;
    margin-left: 107px;
    margin-right: 56px;
    width: 356px;
    height: 307px;
    display: inline-block;
    vertical-align: top;
  }

  .slogan {
    position: absolute;
    left: 195px;
    bottom: 116px;
    .slogan_text {
      font-size: 18px;
      color: #20366c;
      display: inline-block;
      vertical-align: top;
    }
    .slogan_point {
      width: 6px;
      height: 6px;
      background-color: #20366c;
      border-radius: 3px;
      display: inline-block;
      vertical-align: top;
      margin-top: 11px;
      margin-left: 5px;
      margin-right: 5px;
    }
  }

  .line {
    margin-top: 114px;
    height: 410px;
    width: 2px;
    background-color: rgba(77, 82, 156, 0.2);
    display: inline-block;
    vertical-align: top;
  }

  .www_btn {
    position: absolute;
    right: 115px;
    top: 60px;
    color: #ffffff;
    background-image: url(../assets/login/www.svg);
    background-size: 18px auto;
    background-position: 15px center;
    font-size: 14px;
    padding-left: 38px;
    background-repeat: no-repeat;
    font-weight: bolder;
    width: 75px;
    height: 34px;
    line-height: 34px;
    background-color: #fabb24;
    text-align: left;
    border-radius: 17px;
  }
  .www_btn:hover {
    opacity: 0.9;
    cursor: pointer;
  }

  .right-wrap {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 328px;
    height: 364px;
    overflow: hidden;
    display: inline-block;
    vertical-align: top;
    background-color: RGBA(255, 255, 255, 1);
    border-radius: 10px;
    margin-top: -164px;
    margin-left: -162px;
    box-shadow: 0px 0px 20px 0px rgba(186, 190, 198, 0.48);
    .close-btn {
      position: absolute;
      right: 15px;
      top: 15px;
      height: 20px;
      width: 20px;
      background-image: url(../assets/common/close-gray.png);
      background-size: 80% 80%;
      background-position: center center;
      background-repeat: no-repeat;
      cursor: pointer;
      opacity: 0.9;
    }
    .login-text1 {
      margin-top: 35px;
      margin-bottom: 15px;
      color: #1a1a1a;
      font-size: 24px;
      font-weight: 600;
      text-align: center;
      height: 32px;
      line-height: 32px;
    }
    .login-switch {
      margin: 0 30px;
      border-bottom: 1px solid RGBA(235, 235, 235, 1);
      .login-switch-item {
        height: 30px;
        line-height: 30px;
        text-align: center;
        color: rgba(153, 153, 153, 1);
        border-bottom: 2px solid transparent;
        display: inline-block;
        vertical-align: top;
        width: 50%;
      }
      .login-switch-item.active,
      .login-switch-item:hover {
        color: #4e4ad2;
        border-bottom: 2px solid #4e4ad2;
        cursor: pointer;
      }
    }
  }

  .login-container {
    display: inline-block;
    vertical-align: top;
    position: relative;
    box-sizing: border-box;
    text-align: center;
    width: 100%;

    .way2 {
      position: absolute;
      right: 0;
      top: 0;
      width: 84px;
      height: 84px;
    }
    .way2:hover {
      cursor: pointer;
    }

    .login-text2 {
      margin-top: 10px;
      color: #666666;
      font-size: 16px;
    }
    .login-text3 {
      margin-top: 5px;
      color: #999999;
      font-size: 14px;
    }

    .qrcode {
      /*width: 120px;*/
      width: 100%;
      height: 142px;
      margin-top: 22px;
      overflow: hidden;
      /*background-color: #ffffff;*/
      position: relative;
      // background-color: #f4f4f4;

      iframe {
        margin-top: 11px;
        width: 400px;
        zoom: 0.5 \0;
        -ms-transform: scale(1) \0;
        -webkit-transform: scale(0.5);
        transform: scale(0.5);
        -ms-transform-origin: left top;
        transform-origin: left top;
        height: 400px;
        position: absolute;
        left: 63px;
        top: -34px;
        // background-color: #f4f4f4;
      }

      .un-checked-xieyi-img {
        width: 130px;
        height: 130px;
        background-image: url("../assets/login/expired.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
        margin: 0 auto;
        margin-top: 5px;
      }
    }

    .xieyi {
      position: relative;
      margin-top: 5px;
      padding: 10px;
      text-align: center;

      .checked-xieyi {
        width: 16px;
        height: 16px;

        background-image: url("../assets/common/redio_select.png");
        background-size: 100% 100%;
        background-repeat: no-repeat;
        display: inline-block;
        vertical-align: top;
        margin-top: 3px;
      }
      .checked-xieyi:hover {
        cursor: pointer;
      }

      .un-checked-xieyi {
        background-image: url("../assets/common/redio_empty.png");
      }

      .xieyi-text {
        // width: 230px;
        margin-left: 4px;
        margin-bottom: 1px;
        color: rgba(153, 153, 153, 1);
        font-size: 12px;
        display: inline-block;
        vertical-align: top;
        height: 20px;
        line-height: 20px;
        text-align: left;

        span {
          color: #3535c1;
          margin: 0 3px;
        }
      }
      .xieyi-text:hover {
        cursor: pointer;
      }
    }

    @keyframes shake-hard {
      0% {
        transform: translate3d(0, -3px, 0);
      }
      8% {
        transform: translate3d(0, 3px, 0);
      }
      16% {
        transform: translate3d(0, -3px, 0);
      }
      24% {
        transform: translate3d(0, 3px, 0);
      }
      32% {
        transform: translate3d(0, -3px, 0);
      }
      40% {
        transform: translate3d(0, 3px, 0);
      }
      48% {
        transform: translate3d(0, -3px, 0);
      }
      56% {
        transform: translate3d(0, 3px, 0);
      }
      64% {
        transform: translate3d(0, -3px, 0);
      }
      72% {
        transform: translate3d(0, 3px, 0);
      }
      80% {
        transform: translate3d(0, -3px, 0);
      }
      88% {
        transform: translate3d(0, 3px, 0);
      }
      96% {
        transform: translate3d(0, -3px, 0);
      }
      98% {
        transform: translate3d(0, -1px, 0);
      }
      99% {
        transform: translate3d(0, 1px, 0);
      }
      100% {
        transform: translate3d(0, 0, 0);
      }
    }
    .xieyiShake {
      animation-name: shake-hard;
      transform-origin: center; /*设置动画旋转元素的基点*/
      animation-duration: 0.3s; /*动画时间*/

      .shake {
        background-image: url("../assets/login/shake.png");
      }
      .xieyi-text {
        color: #f1403c;
        span {
          color: #f1403c;
        }
      }
    }
  }

  .login-container-way2 {
    .input-wrap.input-wrap-hover {
      // box-shadow: 0 2px 8px 1px rgba(149, 181, 250, 1);
      //   border: 1px solid rgba(149, 181, 250, 1);
      //   background-color: rgba(255, 255, 255, 1);
      .code,
      .phone {
        // background-color: RGBA(255, 255, 255, 1);
      }
    }
    .input-wrap {
      position: relative;
      overflow: hidden;
      width: 258px;
      height: 42px;
      box-sizing: border-box;
      margin-left: 25px;
      margin: 0 auto;
      border-radius: 48px;
      background: #faf7fe;

      img {
        position: absolute;
        left: 23px;
        top: 11px;
        width: 20px;
        height: 20px;
      }
      .phone,
      .code {
        padding-left: 51px;
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        color: #4a4a4a;
        font-size: 14px;
        background-color: rgba(242, 242, 242, 1);
      }
      .code-btn {
        position: absolute;
        right: 0;
        width: 87px;
        line-height: 42px;
        height: 42px;
        background-color: #4e4ad2;
        font-size: 12px;
        text-align: center;
        color: #ffffff;
        box-sizing: border-box;
      }
      .code-btn:hover {
        cursor: pointer;
      }
      .countdown {
        padding-right: 8px;
        text-align: right;
      }

      input::-webkit-outer-spin-button,
      input::-webkit-inner-spin-button {
        -webkit-appearance: none;
      }
      input[type="number"] {
        -moz-appearance: textfield;
      }

      .phone-error1,
      .phone-error2 {
        height: 35px;
        line-height: 35px;
        width: 213px;
        color: #f1403c;
        font-size: 12px;
        box-sizing: border-box;
      }
      .phone-error1,
      .code-error1 {
        position: absolute;
        right: 10px;
        top: 4px;
        // background-color: #e5e5e5;
        /*top: 50%;*/
        /*transform: translate(0,-50%);*/
      }
      .phone-error2 {
        position: absolute;
        text-align: right;
        padding-right: 8px;
        right: 0;
        top: 0;
        /*top: 50%;*/
        /*transform: translate(0,-50%);*/
      }
      .phone-error1 {
        right: 10px;
        text-align: right;
      }
      .code-error1,
      .code-error2 {
        height: 35px;
        line-height: 35px;
        width: 126px;
        color: #f1403c;
        font-size: 12px;
        box-sizing: border-box;
      }
      .code-error1 {
        right: 90px;
        text-align: right;
      }

      .code-error2 {
        position: absolute;
        text-align: right;
        right: 90px;
        top: 3px;
      }
    }
    .code-wrap {
      margin-top: 15px;
    }
    .phone-wrap {
      // border: 1px solid rgba(149, 181, 250, 1);
      margin-top: 23px;
    }

    .xieyi {
      margin-top: 18px;
      padding: 0 10px;
    }

    .login-btn {
      margin: 0 auto;
      margin-top: 28px;
      width: 258px;
      height: 42px;
      line-height: 42px;
      text-align: center;
      color: #ffffff;
      font-size: 16px;
      font-weight: 600;
      border-radius: 76px;
      background-color: #3535c1;
      background-image: var(
        --unnamed,
        linear-gradient(188deg, #655de1 0%, #3535c1 100%)
      );
      box-shadow: 0px 4px 8px 0px rgba(25, 24, 106, 0.16);
    }
    .login-btn:hover {
      cursor: pointer;
      opacity: 0.9;
    }
  }

  .login-bind-wrap {
    .login-text1 {
      margin-top: 31px;
    }
    .bind-icon {
      width: 82px;
      height: 82px;
      border-radius: 82px;
    }
    .bind-name {
      margin-top: 3px;
      color: #666666;
      font-size: 12px;
    }
    .bind-tip {
      margin-top: 18px;
      color: #191919;
      font-size: 12px;
    }
    .phone-wrap {
      margin-top: 20px;
    }
    .login-btn {
      display: inline-block;
      margin-top: 23px;
      width: 179px;
    }
    .bind-skip {
      margin-right: 15px;
      margin-left: 8px;
      display: inline-block;
      font-size: 12px;
      color: #999999;
      border-bottom: 1px solid #999999;
    }
    .bind-skip:hover {
      cursor: pointer;
    }
  }

  .bg-wrap {
    width: 428px;
    height: 450px;
    overflow: hidden;
    margin-top: 141px;
    margin-left: 65px;
    margin-right: 30px;
    display: inline-block;
    vertical-align: top;
  }

  .swiper-container {
    width: 860px;
    height: 380px;
    text-align: center;
    img {
      width: 100%;
    }
  }

  .swiper-wrapper {
    width: 428px;
    height: 380px;
  }

  .swiper-slide {
    width: 428px;
    height: 330px;
    background-size: 100% auto;
    background-position: center center;
    background-repeat: no-repeat;
    display: inline-block;
    vertical-align: top;
  }
  .swiper-slide.swiper-slide-01 {
    width: 428px;
    height: 330px;
    img {
      width: 428px;
      height: 320px;
    }
  }
  .swiper-slide.swiper-slide-02 {
    width: 428px;
    height: 330px;
    img {
      width: 320px;
      height: 328px;
    }
  }
}
</style>


<style>
.bg-wrap .swiper-pagination {
  height: 20px;
  text-align: center;
}
.bg-wrap .swiper-pagination-bullet {
  width: 8px;
  height: 8px;
  border-radius: 4px;
  background: #d9d9d9;
  opacity: 1;
}
.bg-wrap .swiper-pagination-switch {
  height: 20px;
  width: 20px;
  display: inline-block;
}
.bg-wrap .swiper-pagination-bullet.swiper-pagination-bullet-active {
  background: #143977;
  width: 16px;
}
</style>